import {
    INICIA_DIARIO,
    INICIO_DIARIO_SUCESSO,
    BUSCA_DIARIO,
    BUSCA_DIARIO_SUCESSO,
    LISTA_CURSOS_DIARIO,
    LISTA_CURSOS_DIARIO_SUCESSO,
    LISTA_SERIES_DIARIO,
    LISTA_SERIES_DIARIO_SUCESSO,
    LISTA_TURMAS_DIARIO,
    LISTA_TURMAS_DIARIO_SUCESSO,
    LANCA_FALTAS_DIARIO,
    LANCA_FALTAS_DIARIO_SUCESSO,
    LIMPAR_DIARIO,
    VOLTAR_PARA_FILTROS_DIARIO,
    TOGGLE_FALTA_DIARIO,
    REABRIR_DIARIO,
    REABRIR_DIARIO_SUCESSO,
    FECHAR_DIARIO,
    FECHAR_DIARIO_SUCESSO,
    HIDE_MESSAGE,
    SHOW_MESSAGE,
    ON_SHOW_SUCCESS_MESSAGE
} from 'constants/ActionTypes';

// Inicialização
export const iniciaDiario = () => ({
    type: INICIA_DIARIO
});

export const inicioDiarioSucesso = (escolas) => ({
    type: INICIO_DIARIO_SUCESSO,
    payload: { escolas }
});

// Busca principal
export const buscaDiario = (filtros) => ({
    type: BUSCA_DIARIO,
    payload: filtros
});

export const buscaDiarioSucesso = (resultado) => ({
    type: BUSCA_DIARIO_SUCESSO,
    payload: resultado
});

// Listagem hierárquica (reutilizando lógica de filtros vindo do NotasFaltas/Global se possível, 
// mas criando ações específicas para manter isolamento de estado)

export const listaCursosDiario = (escolaId, anoLetivo) => ({
    type: LISTA_CURSOS_DIARIO,
    payload: { escolaId, anoLetivo }
});

export const listaCursosDiarioSucesso = (cursos) => ({
    type: LISTA_CURSOS_DIARIO_SUCESSO,
    payload: cursos
});

export const listaSeriesDiario = (cursoId) => ({
    type: LISTA_SERIES_DIARIO,
    payload: { cursoId }
});

export const listaSeriesDiarioSucesso = (series) => ({
    type: LISTA_SERIES_DIARIO_SUCESSO,
    payload: series
});

export const listaTurmasDiario = (ano, escolaId, serieId) => ({
    type: LISTA_TURMAS_DIARIO,
    payload: { ano, escolaId, serieId }
});

export const listaTurmasDiarioSucesso = (turmas) => ({
    type: LISTA_TURMAS_DIARIO_SUCESSO,
    payload: turmas
});

// Lançamento de faltas
export const lancaFaltasDiario = (dados) => ({
    type: LANCA_FALTAS_DIARIO,
    payload: dados
});

export const lancaFaltasDiarioSucesso = (resultado) => ({
    type: LANCA_FALTAS_DIARIO_SUCESSO,
    payload: resultado
});

// Interação local
export const toggleFaltaDiario = (dados) => ({
    type: TOGGLE_FALTA_DIARIO,
    payload: dados // { matriculaId, componenteEscolaId, faltou }
});

export const reabrirDiario = (id) => ({
    type: REABRIR_DIARIO,
    payload: id
});

export const reabrirDiarioSucesso = () => ({
    type: REABRIR_DIARIO_SUCESSO
});

export const fecharDiario = (id) => ({
    type: FECHAR_DIARIO,
    payload: id
});

export const fecharDiarioSucesso = () => ({
    type: FECHAR_DIARIO_SUCESSO
});

// Navegação e Limpeza
export const limparDiario = () => ({
    type: LIMPAR_DIARIO
});

export const voltarParaFiltrosDiario = () => ({
    type: VOLTAR_PARA_FILTROS_DIARIO
});

// Mensagens
export const hideMessage = () => ({
    type: HIDE_MESSAGE
});

export const showAuthMessage = (message) => ({
    type: SHOW_MESSAGE,
    payload: message
});

export const showSuccessMessage = (message) => ({
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
});
